import React from 'react';
import * as echarts from 'echarts';
import styles from './brain-science-chart.css';

class BrainScienceChart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            brainScienceData: this.props.brainScienceData,
            barChartsTimer: null,
            lineChartsTimer: null,
            gaugeChartTimer: null,
            radarChartTimer: null,
            keysArray: ['delta', 'theta', 'alpha1', 'alpha2', 'beta1', 'beta2', 'gamma1', 'gamma2']
        }
    }

    componentDidMount() {
        this.initBarCharts();
        this.initLineCharts();
        this.initGaugeCharts();
        this.initRadarCharts();
    }

    //柱状图
    initBarCharts() {
        const myChart = echarts.init(document.getElementById('barCharts'));
        const { keysArray } = this.state;

        const option = {
            tooltip: {
                axisPointer: {
                    animation: false
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: ['δ', 'θ', 'α1', 'α2', 'β1', 'β2', 'γ1', 'γ2'],
                axisTick: {
                    alignWithLabel: true
                },
                ameTextStyle: {
                    fontSize: 14
                },

            },
            yAxis: {
                type: 'value',
                max: 24
            },
            series: [{
                type: 'bar',
                barWidth: 20,//柱图宽度
                itemStyle: {
                    borderRadius: [10, 10, 0, 0],
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#f45c3d'
                        }, {
                            offset: 1, color: '#f9bf6b'
                        }],
                        globalCoord: true
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#222222'
                        }
                    },
                },
                data: [0, 0, 0, 0, 0, 0, 0, 0],
            }],
            legend: {
                show: true
            },
            // animationDuration: 0,
            animationDurationUpdate: 1000,
            animationEasing: 'linear',
            animationEasingUpdate: 'linear'
        };

        myChart.setOption(option);

        //更新
        const barChartsTimer = setInterval(() => {
            const _valuesArray = []
            const brainScienceData = this.state.brainScienceData;
            const _curent = brainScienceData[brainScienceData.length - 1];
            keysArray.forEach(item => {
                _valuesArray.push(_curent[item])
            })
            myChart.setOption(Object.assign(option, {
                series: [{
                    data: _valuesArray
                }]
            }));
        }, 1000);

        this.setState({
            barChartsTimer
        })
    }

    //折线图
    initLineCharts() {
        const that = this;
        const myChart = echarts.init(document.getElementById('lineCharts'));
        const { brainScienceData } = this.state;

        const option = {
            title: {
                text: '专注度和放松度',
                left: 'center'
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {
                data: ['专注度', '放松度'],
                right: 10,
                top: 20
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                splitLine: {
                    show: true,
                },
                triggerEvent: true,
                axisLabel: {
                    interval: 0,
                    rotate: 45,
                    show: false
                },
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, '100%'],
                max: 100,
                splitLine: {
                    show: true,
                },
            },
            series: [
                {
                    name: '专注度',
                    type: 'line',
                    showSymbol: false,
                    emphasis: {
                        scale: false
                    },
                    lineStyle: {
                        color: "rgba(183, 196, 29, 0.9)"
                    },
                    itemStyle: {
                        color: "rgba(183, 196, 29, 1)"
                    },
                    data: [],
                },
                {
                    name: '放松度',
                    type: 'line',
                    showSymbol: false,
                    emphasis: {
                        scale: false
                    },
                    lineStyle: {
                        color: "rgba(21, 129, 174, 0.9)"
                    },
                    itemStyle: {
                        color: "rgba(21, 129, 174, 1)"
                    },
                    data: [],
                },
            ],
        };

        function randomData(now, value1, value2) {
            return {
                name: now.toString(),
                value: [that.dateFormate(now, 'yyyy-MM-dd hh:mm:ss'), value1, value2],
            }
        }

        function initData(now, value1, value2) {
            return {
                name: now.toString(),
                value: [that.dateFormate(now, 'yyyy-MM-dd hh:mm:ss'), value1, value2],
            }
        }

        const data = [];
        const times = 15;
        const now = new Date() - times * 1000;
        //初始化数据
        for (let i = 1; i <= times; i++) {
            let len = brainScienceData.length;
            if (i <= times - len) {
                data.push(initData(new Date(now + 1000 * i), 0, 0))
            } else {
                const { att, med } = brainScienceData[len - (times - i) - 1];
                data.push(initData(new Date(now + 1000 * i), att, med))
            }
        }
        let options = Object.assign(option, {});
        const data1 = [], data2 = [], data3 = [];
        data.forEach(item => {
            data1.push(item.value[0]);
            data2.push(item.value[1])
            data3.push(item.value[2])
        })
        options.xAxis.data = data1;
        options.series.forEach((item, index) => {
            if (index == 0) {
                item.data = data2
            } else {
                item.data = data3
            }
        })
        myChart.setOption(options)

        // 定时器
        const lineChartsTimer = setInterval(() => {
            const { brainScienceData } = this.state;
            const _curent = brainScienceData[brainScienceData.length - 1];
            const { att, med } = _curent;
            data.shift()
            data.push(randomData(new Date(), att, med))
            const _data1 = [], _data2 = [], _data3 = [];
            data.forEach(item => {
                _data1.push(item.value[0]);
                _data2.push(item.value[1])
                _data3.push(item.value[2])
            })
            options.xAxis.data = _data1;
            options.series.forEach((item, index) => {
                if (index == 0) {
                    item.data = _data2
                } else {
                    item.data = _data3
                }
            })
            myChart.setOption(options)
        }, 1000)

        this.setState({
            lineChartsTimer
        })
    }

    //仪表盘 专注度和放松度
    initGaugeCharts() {
        const myChart1 = echarts.init(document.getElementById('gaugeChart1'));
        const myChart2 = echarts.init(document.getElementById('gaugeChart2'));
        const option = {
            tooltip: {
                formatter: '{a} <br/>{b} : {c}'
            },
            series: [{
                name: '专注度',
                type: 'gauge',
                pointer: {
                    itemStyle: {
                        color: 'auto'
                    }
                },
                axisTick: {
                    distance: -30,
                    length: 8,
                    lineStyle: {
                        color: '#fff',
                        width: 2
                    }
                },
                splitLine: {
                    distance: -30,
                    length: 30,
                    lineStyle: {
                        color: '#fff',
                        width: 4
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 10,
                        color: [[0.1, '#fff159'], [0.2, '#ffe259'],[0.3, '#ffd259'], [0.4, '#ffc259'], [0.5, '#ffb359'],
                        [0.6, '#ffab59'], [0.7, '#ff9f59'], [0.8, '#fe843f'], [0.9, '#ff6c1c'], [1, '#f35803']],
                        shadowColor: '#fff',
                        shadowBlur: 10
                    }
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}',
                    textStyle: {
                        fontWeight: 'bolder',
                        fontSize: 16
                    }
                },
                data: []
            }]
        };

        const gaugeChartTimer = setInterval(() => {
            let brainScienceData = this.state.brainScienceData;
            const _curent = brainScienceData[brainScienceData.length - 1];
            let { att, med } = _curent;
            let options = Object.assign(option, {});
            let optionsCopy = JSON.parse(JSON.stringify(option));

            options.series[0].data = [{
                value: att,
                name: '专注度',
                title: {
                    fontSize: 12,
                    lineHeight: 24
                }
            }]

            optionsCopy.series[0].name = '放松度'
            optionsCopy.series[0].data = [{
                value: med,
                name: '放松度',
                title: {
                    fontSize: 12,
                    lineHeight: 24
                }
            }]

            myChart1.setOption(options);
            myChart2.setOption(optionsCopy);
        }, 1000);

        this.setState({
            gaugeChartTimer
        })
    }

    //雷达图
    initRadarCharts() {
        const myChart = echarts.init(document.getElementById('radarCharts'));
        const option = {
            radar: {
                shape: 'circle',
                indicator: [
                    { text: 'Delta', max: 24 },
                    { text: 'Theta', max: 24 },
                    { text: 'LowAlpha', max: 24 },
                    { text: 'HighAlpha', max: 24 },
                    { text: 'LowBeta', max: 24 },
                    { text: 'HighBeta', max: 24 },
                    { text: 'LowGamma', max: 24 },
                    { text: 'HighGamma', max: 24 }
                ],
                name: {
                    textStyle: {
                        color: '#f35803',
                        // backgroundColor: '#555',
                        borderRadius: 3,
                        // padding: [3, 4]
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: [
                            'rgba(238, 197, 102, 0.1)', 'rgba(238, 197, 102, 0.2)',
                            'rgba(238, 197, 102, 0.4)', 'rgba(238, 197, 102, 0.6)',
                            'rgba(238, 197, 102, 0.8)', 'rgba(238, 197, 102, 1)'
                        ]
                    }
                },
                splitArea: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(238, 197, 102, 0.5)'
                    }
                }
            },
            series: [{
                name: '脑电参数',
                type: 'radar',
                data: [
                    {
                        value: [0, 0, 0, 0, 0, 0, 0, 0],
                        areaStyle: {
                            color: new echarts.graphic.RadialGradient(0.4, 0.8, 1, [
                                {
                                    color: 'rgba(255,150,27,0.1)',
                                    offset: 0
                                },
                                {
                                    color: '#ff6f1f',
                                    offset: 1
                                }
                            ])
                        }
                    }
                ],
                lineStyle: {
                    normal: {
                        width: 1,
                        opacity: 0.5
                    }
                },
                symbol: 'none',
                itemStyle: {
                    color: '#F9713C'
                }
            }]
        };

        option && myChart.setOption(option);

        const radarChartTimer = setInterval(() => {
            let _valuesArray1 = [];
            const { keysArray, brainScienceData } = this.state;
            const last = brainScienceData[brainScienceData.length - 1]; //倒数1
            keysArray.forEach(item => {
                _valuesArray1.push(last[item])
            })
            let options = Object.assign(option, {});
            options.series[0].data[0].value = _valuesArray1;
            myChart.setOption(options);
        }, 1000);

        this.setState({
            radarChartTimer
        })

    }

    dateFormate(time, fmt) {
        var now = time || new Date();
        var o = {
            "y+": now.getFullYear(), //年
            "M+": now.getMonth() + 1, //月
            "d+": now.getDate(), //日
            "h+": now.getHours(), //小时
            "m+": now.getMinutes(), //分
            "s+": now.getSeconds(), //秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                (now.getFullYear() + "").substr(4 - RegExp.$1.length)
            );
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                );
        return fmt;
    }

    componentWillUnmount() {
        this.state.barChartsTimer && clearInterval(this.state.barChartsTimer)
        this.state.lineChartsTimer && clearInterval(this.state.lineChartsTimer)
        this.state.gaugeChartTimer && clearInterval(this.state.gaugeChartTimer)
        this.state.radarChartTimer && clearInterval(this.state.radarChartTimer)
    }

    componentWillReceiveProps(nextProps){
        console.log("arg",nextProps);
    }

    render() {
        return (
            <div className={styles.modalChartsContainer}>
                <div className={styles.chartBox}>
                    <div id="radarCharts" style={{ width: '40%', height: 300 }}></div>
                    <div id="lineCharts" style={{ width: '60%', height: 300 }}></div>
                </div>
                <div className={styles.chartBox}>
                    <div id="barCharts" style={{ width: '40%', height: 300 }}></div>
                    <div id="gaugeChart1" style={{ width: '30%', height: 300 }}></div>
                    <div id="gaugeChart2" style={{ width: '30%', height: 300 }}></div>
                </div>
            </div>
        )
    }

}
export default BrainScienceChart
